import { render, staticRenderFns } from "./SelectWorldsTransfer.vue?vue&type=template&id=b81137b0&scoped=true&"
import script from "./SelectWorldsTransfer.vue?vue&type=script&lang=js&"
export * from "./SelectWorldsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SelectWorldsTransfer.vue?vue&type=style&index=0&id=b81137b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81137b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VSelect})
